import { supabase } from '@/lib/supabase/client';

interface RecentDiscussionActivityRow {
  id: string;
  event_id: string;
  profile_id: string;
  content: string;
  created_at: string;
}

interface RecentResultActivityRow {
  id: string;
  event_id: string;
  uploader_profile_id: string;
  caption: string | null;
  created_at: string;
}

export interface RecentDiscussionActivity {
  id: string;
  eventId: string;
  profileId: string;
  content: string;
  createdAt: string;
}

export interface RecentResultActivity {
  id: string;
  eventId: string;
  uploaderProfileId: string;
  caption?: string;
  createdAt: string;
}

function assertSupabase() {
  if (!supabase) {
    throw new Error('Supabase is not configured.');
  }

  return supabase;
}

export async function listRecentDiscussionActivity(limit = 12): Promise<RecentDiscussionActivity[]> {
  const client = assertSupabase();
  const { data, error } = await client
    .from('event_discussion_messages')
    .select('id, event_id, profile_id, content, created_at')
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) {
    throw new Error(error.message);
  }

  return ((data ?? []) as RecentDiscussionActivityRow[]).map((row) => ({
    id: row.id,
    eventId: row.event_id,
    profileId: row.profile_id,
    content: row.content,
    createdAt: row.created_at,
  }));
}

export async function listRecentResultActivity(limit = 12): Promise<RecentResultActivity[]> {
  const client = assertSupabase();
  const { data, error } = await client
    .from('event_result_assets')
    .select('id, event_id, uploader_profile_id, caption, created_at')
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) {
    throw new Error(error.message);
  }

  return ((data ?? []) as RecentResultActivityRow[]).map((row) => ({
    id: row.id,
    eventId: row.event_id,
    uploaderProfileId: row.uploader_profile_id,
    caption: row.caption ?? undefined,
    createdAt: row.created_at,
  }));
}
